import {Component, HostListener} from '@angular/core';
import {AuthService} from "../../../services/auth.service";
import {ConfigService} from "../../../services/config.service";

@Component({
  selector: 'app-sidebar-structure',
  templateUrl: './sidebar-structure.component.html',
  styleUrls: ['./sidebar-structure.component.scss']
})
export class SidebarStructureComponent {
  token: string | null = null;
  sidebarToggled = false;
  manualToggle: boolean | null = null;

  isRival: boolean;
  hasMinReg: boolean;

  constructor(
    private configs: ConfigService,
    private authService: AuthService
  ) {
    this.isRival = this.configs.isRivalCasino;
    this.hasMinReg = this.configs.hasMinimalRegistration;

    this.authService.token.subscribe((token: string | null)=>{
      this.token = token;
    })

    if ( typeof window !== 'undefined' && window.innerWidth >= 768){
      this.sidebarToggled = true;
    }
  }


  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    if (this.manualToggle === null) {
      this.sidebarToggled = event.target.innerWidth >= 768;
    }
  }

  onSidebarToggle(sidebarToggled: boolean) {
    this.sidebarToggled = sidebarToggled;
    this.manualToggle = true;
  }


}
